<template>
  <div class="loginContainer">
    <div class="logo-main">
      <img class="logo-bg" :src="$tenant.landing1">
      <div class="login" @keydown.enter="login">
        <div class="login-con" style="margin-top: 18%">
          <el-card>
            <div slot="header">
              <span>{{loginText}}</span>
            </div>
            <el-form ref="loginForm" :model="user" :rules="rules">
              <el-form-item prop="username">
                <el-input v-model="user.username" placeholder="请输入账号" size="medium">
                  <template slot="prepend">账 号</template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input 
                    v-model="user.password"
                    placeholder="请输入密码"
                    type="password"
                    size="medium"
                    show-password>
                  <template slot="prepend">密 码</template>
                </el-input>
              </el-form-item>
              <el-form-item v-if="showCaptcha" prop="captcha">
                <div style="display: flex; align-items: center;">
                  <el-input
                      v-model="user.captcha"
                      placeholder="请输入验证码"
                      size="medium"
                      clearable
                      maxlength="4">
                    <template slot="prepend">验证码</template>
                  </el-input>
                  <img class="captcha-img" :src="captchaImg" style="height: 36px;margin-left: 5px" @click="getCaptcha()">
                </div>
              </el-form-item>
              <div class="login-btn">
                <el-button :loading="loading" size="medium" type="primary" @click="login"> 立即登录 </el-button>
                <el-button
                    type="text"
                    class="changePwd"
                    size="medium"
                    style="float: right"
                    @click="changePwd">
                  修改密码
                </el-button>
              </div>
            </el-form>
          </el-card>
        </div>
      </div>
    </div>
    <div class="copyright"/>
    <change-pwd ref="changePwdDialog"/>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ChangePwd from "@/views/main/ChangePwd.vue";
  const isDev = process.env.NODE_ENV === "development";
  export default {
    components: {ChangePwd},
    data() {
      return {
        loginText: "登录",
        dialogVisible: false,
        countdownSeconds: 60,
        sendMsgBtnDisabled: false,
        sendMsgBtnText: "发送短信",
        sendMsgBtnLoading: false,
        registerSendMsgBtnLoading: false,
        captchaImg: "",
        showCaptcha: false,
        user: {
          username: "",
          password: "",
          captchaKey: "",
          captcha: "",
          loginType: 2,
        },
        rules: {
          username: { required: true, message: "账号不能为空", trigger: "blur" },
          password: { required: true, message: "密码不能为空", trigger: "blur" },
          captcha: {required: true, message: "验证码为4位", trigger: "blur", max: 4, min: 4},
        },
        loading: false,
      };
    },
    created() {
      // 在组件创建时初始化所有属性
      this.showCaptcha = loginUtil.isShowCaptcha();
      if (isDev) {
        this.user.username = "admin";
        this.user.password = "Step2026";
      }
    },
    mounted() {
      // 在组件挂载后尝试从window.config获取loginText
      if (window.config && window.config.loginText) {
        this.loginText = window.config.loginText;
      }
      if (this.showCaptcha) {
        this.getCaptcha();
      }
    },
    methods: {
      login() {
        const hasRepeatedDigits = /(\d)\1{2}/;
        if (hasRepeatedDigits.test(this.user.password)) {
          return this.$message.error("按照监管要求，密码禁止出现重复数字，请修改密码！");
        }
        const hasSequentialDigits = /(?:012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210)/;
        if (hasSequentialDigits.test(this.user.password)) {
          return this.$message.error("按照监管要求，密码禁止出现连续数字，请修改密码！");
        }
        // eslint-disable-next-line no-useless-escape
        const passwordRegex = /^(?!.*(\d)\1{2})(?!.*(?:012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210))(?:(?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])|(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])|(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])).{8,20}$/;
        if (!passwordRegex.test(this.user.password)) {
          return this.$message.error("按照监管要求，密码必须包含【大写字母、小写字母、数字、符号】中的3种组合，长度为8-20位。");
        }
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
              .post("basic", "account/loginWithCaptcha", this.user)
              .then((resp) => {
                if(resp.success) {
                  loginUtil.clearAllStorage();
                  this.loading = false;
                  loginUtil.login(resp.data);
                  loginUtil.hideCaptcha();
                  this.showCaptcha = false;
                  this.$router.push({path: "/"});
                }
              })
              .catch((error) => {
                console.log("error", error);
                const status = error.code;
                if (status === 428) {
                  this.$confirm(error.message, "提示", {
                    type: "warning",
                    confirmButtonText: "更改密码",
                  }).then(() => {
                    this.changePwd();
                  });
                } else {
                  loginUtil.showCaptcha();
                  this.showCaptcha = true;
                  this.getCaptcha();
                  this.user.captcha = "";
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
      },
      changePwd() {
        if (!this.user.username) {
          return this.$message.error("请先输入账号");
        }
        this.$refs.changePwdDialog.open(this.user.username);
      },
      getCaptcha() {
        this.$http.get("basic", "captcha/getBase64")
          .then(data => {
            this.user.captchaKey = data.key;
            this.captchaImg = data.img;
          });
      },
    },
  };
</script>

<style lang="scss">
.loginContainer {
  width: 100%;
  height: 100%;
  background-color: #0d3672 !important;
  .logo-main {
    width: 100%;
    height: 90%;
    img {
      width: 50%;
      float: left;
      margin-top: 5%;
      margin-left: 3%;
    }
    .el-input--medium .el-input__inner {
      height: 46px !important;
      line-height: 46px !important;
    }
    .el-input-group > .el-input-group__prepend {
      width: 60px !important;
    }
    .login {
      width: 45%;
      text-align: center;
      float: right;
      margin-top: 3%;
      margin-right: 1%;
      .clear {
        clear: both;
      }
      &-con {
        margin: 0 auto;
        width: 60%;
        img {
          margin: 5% auto;
        }
        .captcha-img{
          margin: 0;
        }
      }
      .login-btn {
        margin: 5% auto 0;
        position: relative;
        padding-bottom: 30px;
        button:not(:last-child) {
          max-width: 400px;
          width: 80%;
          height: 3rem;
          font-size: 1rem;
          border: none;
          border-radius: 30px;
          background: #124da3;
        }
        button:nth-child(1) {
          color: #ffffff;
        }
        .el-button--text{
          position: absolute;
          bottom: -12px;
          right: 0;
        }
        .el-button--text:focus, .el-button--text:hover{
          color: #57a3f3;
          border-color: transparent;
          background-color: transparent;
        }
      }
    }
  }
  .copyright {
    text-align: center;
    color: white;
  }
 
}
</style>
